<template>
  <div v-editable="blok" class="blok">
    <a :id="blok.anchor"></a>
    <div class="recipe-arrows-container" v-if="renderer_view_props.is_strip">
      <div class="recipe-arrows">
        <a class="arrow left prev" href="javascript://" @click="scrollBackRecipes">
          <svg width="72" height="18" viewBox="0 0 72 18" xmlns="http://www.w3.org/2000/svg">
            <g stroke="#30323D" stroke-width="2" fill="none" fill-rule="evenodd">
              <path stroke-linecap="square" d="M63 2.3l7 7-7 7"></path>
              <path d="M69 9.3L1 8.7"></path>
            </g>
          </svg>
        </a>
        <a class="arrow right next" href="javascript://" @click="scrollForwardRecipes">
          <svg width="72" height="18" viewBox="0 0 72 18" xmlns="http://www.w3.org/2000/svg">
            <g stroke="#30323D" stroke-width="2" fill="none" fill-rule="evenodd">
              <path stroke-linecap="square" d="M63 2.3l7 7-7 7"></path>
              <path d="M69 9.3L1 8.7"></path>
            </g>
          </svg>
        </a>
      </div>
    </div>
    <div class="recipes-container" ref="gridArea">
      <component
        @selectRecipe="onRecipeSelected"
        @addToBasket="onAddToBasket"
        @recipeView="onRecipeView"
        @removeFromBasket="removeAllRecipeInstancesFromBasket"
        :key="index"
        v-for="(child,index) in blok.renderer"
        :selectable="blok.allow_recipe_details"
        :allowDetails="blok.allow_recipe_details"
        :recipes="filteredAndSortedRecipes"
        :blok="captureRecipeRendererViewType(child)"
        :is="child.component"
        refs="recipeRenderer"
      ></component>
    </div>
    <div v-if="blok.allow_recipe_details" ref="recipeDetail" class="recipes-container">
      <recipe-details-basic
        @close="onDetailClose"
        @addToBasket="onAddToBasket"
        @removeFromBasket="removeAllRecipeInstancesFromBasket"
        :disablePurchase="blok.details_disable_purchase"
        :hidePrices="blok.details_hide_price"
        :allowDetails="blok.allow_recipe_details"
        v-if="blok.allow_recipe_details && selectedRecipe"
        :blok="blok"
        :recipe="selectedRecipe"
      ></recipe-details-basic>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';

import { mapActions, mapState, mapGetters } from "vuex";

import SimpleRecipeGrid from "./recipeViews/SimpleRecipeGrid.vue";
import PromotionList from "./recipeViews/PromotionList.vue";
import LowestPricedRecipes from "./recipeViews/LowestPricedRecipes.vue";
import RecipeDetailsBasic from "./recipeDetailViews/RecipeDetailsBasic.vue";
import RecipeFilters from "./recipes/RecipeFilters";
import ProfileShippingRun from './profile/ProfileShippingRun.vue';
import ProfilePeople from './profile/ProfilePeople.vue';

import { setTimeout } from "timers";
import * as ls from 'local-storage';
import * as moment from 'moment';

export default {
  name: "recipes-container",
  data: () => {
    return {
      recipes: [],
      selectedRecipe: null,
      shipping_runs: null,
      renderer_view_props: {
        is_strip: false
      }
    };
  },
  components: {
    "recipesview-simple_grid": SimpleRecipeGrid,
    "recipesview-lowest-priced": LowestPricedRecipes,
    RecipeDetailsBasic,
    RecipeFilters,
    ProfilePeople,
    ProfileShippingRun,
    PromotionList
  },
  props: {
    blok: Object
  },
  mounted: function() {
    if(this.runs.length==0){
      this.getLatestShippingRuns().then(v=>{
        this.updateRecipes(this.defaultExcludedGroups,this.defaultMealPlan,this.defaultShippingRun);
      })
    } else {
      this.updateRecipes(this.defaultExcludedGroups,this.defaultMealPlan,this.defaultShippingRun);
    };
  },
  methods: {
    ...mapActions("recipes", ["getLatestShippingRuns", "getRecipes", "filterRecipes"]),
    ...mapActions("profile", ["updateMealPreferences","validateProfile","setShippingDate"]),
    ...mapActions("analytics", ["trackSelectProduct","trackProductListing"]),
    ...mapActions("basket", ["addItem","transFormRecipeToGA","emptyBasket","removeAllFromBasket"]),
    captureRecipeRendererViewType(blok) {
      this.renderer_view_props.is_strip = blok.styles.indexOf('strip')!=-1;
      return blok
    },
    scrollForwardRecipes() {
      this.$refs.gridArea.scrollLeft += (318+16);
    },
    scrollBackRecipes() {
      this.$refs.gridArea.scrollLeft -= (this.$refs.gridArea.scrollLeft>=(318+16)) ? (318+16) : this.$refs.gridArea.scrollLeft;
    },
    updateRecipes(groups,plan,run) {
      if(run!=0) {
        const g = groups.map( v => v.name ? v.name : v );
        this.getRecipes({
          id: run,
          query: groups
            ? g
                .map(v => ["excluded_foods%5B%5D=", v].join(""))
                .join("&")
            : "",
          meal_plan: plan ? plan : ""
        }).then(data => {
          this.restoreRecipes(data.recipes);
          if (!this.blok.filter) {
            this.recipes = data.recipes;
          } else {
            const filter = this.blok.filter;
            if(filter=='selected') {
              this.filterRecipes({
                filter: 'selected',
                recipes: data.recipes,
                selected: this.items.map(v => v.recipe)
              }).then( v => {
                this.recipes = v;
              })
            } 
          }
        });
      }
    },
    restoreRecipes(recipes) {
      const previousRecipes = ls.get('basket.lastbasket_recipes');
      const queryIds = this.$route.query.selected_recipes;
      if(this.items.length==0
        && (queryIds||previousRecipes)
        && this.$props.blok.restore_recipes_from_query) {
          const recipeIds = (queryIds && queryIds.length>0 
            ? queryIds.split(',') : previousRecipes).map(n=>Number(n));
        if(recipeIds){
          recipes.forEach( (v,i) => {
            if(recipeIds.indexOf(v.id)!=-1) {
              this.onAddToBasket({
                recipe: v,
                index: i
              });
            }
          });
        }
      }
    },
    attachCartItemMeta: function(item,position=0) {
      const b = this.$props.blok;
      item.list = b.list_name.toLowerCase().replace(' ', '_');
      item.people = this.meal_preferences.people,
      item.meal_plan = this.meal_preferences.meal_plan
      item.affiliation = b.analytics_affiliation;
      item.variant = this.meal_preferences.people;
      item.list_position = position;
      item.voucher = this.voucher_code;
      item.shipping_run = this.meal_preferences.shipping_date ? this.meal_preferences.shipping_date.id : null;
      item.shipping_run_day = this.meal_preferences.shipping_date ? this.meal_preferences.shipping_date.day : null;
      item.shipping_run_date = this.meal_preferences.shipping_date ? this.meal_preferences.shipping_date.date : null;
    },
    onRecipeView(data) {
      const b = this.$props.blok;
      this.attachCartItemMeta(data,data.index);
      this.transFormRecipeToGA(data).then((v)=>{
        v.affiliation = b.analytics_affiliation;
        v.price = (data.recipe.fractional_prices_for_portions[this.meal_preferences.people]/100);
        this.trackProductListing(v);
      });
    },
    onRecipeSelected(data) {
      const b = this.$props.blok;
      this.selectedRecipe = data.recipe;
      this.attachCartItemMeta(data,data.index);
      this.transFormRecipeToGA(data).then((v)=>{
        v.price = (data.recipe.fractional_prices_for_portions[this.meal_preferences.people]/100);
        this.trackSelectProduct(v);
      });
      if(this.$props.blok.allow_recipe_details) {
        setTimeout(() => {
          this.$refs.recipeDetail.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }, 300);
      }
    },
    onDetailClose() {
      this.selectedRecipe = null;
      this.$refs.gridArea.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    },
    onAddToBasket(data) {
      const b = this.$props.blok;
      const recipe = data.recipe;
      const basketItem = {
        name: recipe.title,
        image: recipe.image_urls.m,
        price: (recipe.fractional_prices_for_portions[this.meal_preferences.people]/100),
        list_position: data.index,
        voucher: this.voucher_code,
        list: b.list_name.toLowerCase().replace(' ', '_'),
        shipping_run: this.meal_preferences.shipping_date ? this.meal_preferences.shipping_date.id : null,
        shipping_run_day: this.meal_preferences.shipping_date ? this.meal_preferences.shipping_date.day : null,
        shipping_run_date: this.meal_preferences.shipping_date ? this.meal_preferences.shipping_date.date : null,
        recipe
      }
      this.attachCartItemMeta(basketItem);
      this.addItem(basketItem);
    },
    removeAllRecipeInstancesFromBasket(v) {
      this.removeAllFromBasket(v.recipe);
    }
  },
  watch: {
    delivery: function(v) {
      this.updateRecipes(this.defaultExcludedGroups,this.defaultMealPlan,this.defaultShippingRun);
    },
    excluded_groups: function(v) {
      if(this.$props.blok.use_profile) {
        this.updateRecipes(this.defaultExcludedGroups,this.defaultMealPlan,this.defaultShippingRun);
      }
    },
    meal_plan: function(v) {
      if(this.$props.blok.use_profile) {
        this.updateRecipes(this.defaultExcludedGroups,this.defaultMealPlan,this.defaultShippingRun);
      }
    },
    '$route.path': function(v,o) {
      if(o!=v){
        this.updateRecipes(this.defaultExcludedGroups,this.defaultMealPlan,this.defaultShippingRun);
      }
    }
  },
  computed: {
    ...mapState({
      runs: state => state.recipes.shipping_runs,
      food_groups: state => state.recipes.food_groups,
      meal_plans: state => state.recipes.meal_plans,
      meal_preferences: state => state.profile.meal_preferences,
      delivery: state => state.profile.meal_preferences.shipping_date,
      excluded_groups: state => state.profile.meal_preferences.excluded_groups,
      meal_plan: state => state.profile.meal_preferences.meal_plan,
      discount_percent: state => state.basket.discountPercent,
      items: state => state.basket.items,
      voucher: state => state.basket.voucher,
      voucher_code: state => state.voucher.code,
      min_recipes: state => state.basket.config.min_count
    }),
    ...mapGetters({
      basketValue: 'basket/total'
    }),
    defaultMealPlan: function() {
      return this.$props.blok.use_profile && this.meal_preferences.meal_plan ? this.meal_preferences.meal_plan : this.$props.blok.meal_plan;
    },
    defaultExcludedGroups: function() {
      return this.$props.blok.use_profile && this.meal_preferences.excluded_groups ? this.meal_preferences.excluded_groups : this.$props.blok.excluded_groups;
    },
    defaultShippingRun: function() {
      const v = this.runs[0];
      let days = 0;
			if (this.meal_preferences.shipping_date) {
				const restoredDate = moment(this.meal_preferences.shipping_date.date);
				const now = moment(v.delivery_days.day_1);
				const duration = moment.duration(restoredDate.diff(now));
				days = Math.floor(duration.asDays());
			}
      if(this.meal_preferences.shipping_date==null||days<0) {
        this.setShippingDate({
                    date: v.delivery_days.day_1,
                    day: 'day_1',
                    id: v.id
                });
      }
      return this.meal_preferences.shipping_date.id;
    },
    filteredAndSortedRecipes: function() {
      return this.recipes;
    }
  }
};
</script>
